
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getTransactionList: {
				custom: true,
				url: (data: any) => `/apis/baohuo-account/v1/transaction/list`,
				method: 'post',
				headers: {
					'content-type': 'application/json'
				}
			},
			getTransactionStyle:`get /apis/baohuo-account/v1/transaction/getProjectList`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"orderPage"
			})
		}